import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const Description = ({
    description,
    descriptionTag,
    descriptionColor,
    descriptionFontFamily,
    descriptionAlign,
    noOfSlides,
    marginTop = '10px',
    marginBottom = {xl: '40px', lg: '10px', md: '20px'}
}) => {
    return (
        <Text
            marginTop={marginTop}
            as={descriptionTag}
            marginBottom={marginBottom}
            fontFamily={descriptionFontFamily || 'body'}
            fontSize={{base: '14px', md: noOfSlides >= 3 ? '14px' : '16px'}}
            color={descriptionColor}
            textAlign={descriptionAlign}
            fontWeight="300"
        >
            {description}
        </Text>
    )
}

Description.propTypes = {
    description: PropTypes.string,
    descriptionTag: PropTypes.string,
    descriptionFontFamily: PropTypes.string,
    descriptionColor: PropTypes.string,
    descriptionAlign: PropTypes.string,
    noOfSlides: PropTypes.any,
    marginTop: PropTypes.string,
    marginBottom: PropTypes.string
}

export default Description
